import { render, staticRenderFns } from "./EditStatusPopup.vue?vue&type=template&id=2e46067c&scoped=true&"
import script from "./EditStatusPopup.vue?vue&type=script&lang=ts&"
export * from "./EditStatusPopup.vue?vue&type=script&lang=ts&"
import style0 from "./EditStatusPopup.vue?vue&type=style&index=0&id=2e46067c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e46067c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
